module.exports = __webpack_public_path__ + "static/media/cls.a2b46c7c.png";